import type { FirehoseMessageHandler } from '../firehose-message-router.js';

export const handlePreviewEnvironmentLogsViewerOpen: FirehoseMessageHandler = (msg, deps) => {
  const environmentId = typeof msg.environmentId === 'string' ? msg.environmentId : '';
  const viewerId = typeof msg.viewerId === 'string' ? msg.viewerId : '';
  if (!environmentId || !viewerId) return;
  deps.previewEnvironmentManager.handleFirehoseLogViewerOpen(environmentId, viewerId);
};
